import React, { useState, useCallback, useEffect } from "react";
import "./menu.css";
import { Link } from "react-router-dom";
import { SlSocialLinkedin } from "react-icons/sl";
import { VscGithubAlt } from "react-icons/vsc";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { MdDarkMode, MdLightMode } from "react-icons/md";

/**
 * Componente de alternância de tema
 */
function ThemeSwitcher() {
  const [theme, setTheme] = useState(() => {
    // Verificar localStorage primeiro
    const savedTheme = localStorage.getItem('app-theme');
    if (savedTheme) return savedTheme;
    
    // Verificar preferência do sistema
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  });

  useEffect(() => {
    console.log('Aplicando tema:', theme);
    
    // Remover atributo anterior
    document.documentElement.removeAttribute('data-theme');
    
    // Aplicar novo tema
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.removeAttribute('data-theme');
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
    }
    
    // Salvar preferência
    localStorage.setItem('app-theme', theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const newTheme = prev === 'light' ? 'dark' : 'light';
      console.log('Alternando para:', newTheme);
      return newTheme;
    });
  }, []);

  return (
    <button
      className="theme-switcher"
      onClick={toggleTheme}
      aria-label={`Alternar para modo ${theme === 'light' ? 'escuro' : 'claro'}`}
      title={`Modo ${theme === 'light' ? 'escuro' : 'claro'}`}
      type="button"
    >
      <span className="theme-icon">
        {theme === 'light' ? (
          <MdDarkMode />
        ) : (
          <MdLightMode />
        )}
      </span>
    </button>
  );
}

/**
 * Componente Menu Lateral
 */
const Menu = ({ url = "home" }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Fechar menu ao clicar em um link
  const handleLinkClick = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Fechar menu ao pressionar ESC
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const navItems = [
    { path: "/", label: "Início", key: "home" },
    { path: "/about", label: "Sobre", key: "about" },
    { path: "/resume", label: "Experiências", key: "resume" },
    { path: "/portfolio", label: "Projetos", key: "portfolio" },
    { path: "/contact", label: "Contato", key: "contact" },
  ];

  return (
    <>
      {/* Hamburger Button */}
      <button
        className={`hamburger ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir menu de navegação"
        aria-expanded={isOpen}
        aria-controls="navbar-menu"
        type="button"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Overlay para fechar menu */}
      {isOpen && (
        <div
          className="menu-overlay"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        ></div>
      )}

      {/* Menu Lateral */}
      <nav
        className={`menu-card ${isOpen ? "open" : ""}`}
        id="navbar-menu"
        role="navigation"
        aria-label="Navegação principal"
      >
        {/* Header com Logo */}
        <div className="menu-header">
          
        </div>

        {/* Navegação Principal */}
        <ul className="menu-ul">
          {navItems.map((item) => (
            <li key={item.key}>
              <Link
                to={item.path}
                className={`menu-link ${url === item.key ? "active" : ""}`}
                onClick={handleLinkClick}
                aria-current={url === item.key ? "page" : undefined}
              >
                <span className="link-text">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>

        {/* Separador */}
        <div className="menu-divider"></div>

        {/* Redes Sociais */}
        <div className="redes-menu">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/leonardo-oliveira-3b0446176/"
            className="social-icon"
            aria-label="Acesse nosso LinkedIn"
            title="LinkedIn"
          >
            <SlSocialLinkedin />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/Leonardu76"
            className="social-icon"
            aria-label="Acesse nosso GitHub"
            title="GitHub"
          >
            <VscGithubAlt />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://api.whatsapp.com/send?phone=5531985808502&text=Olá! Vim através do site"
            className="social-icon"
            aria-label="Contato via WhatsApp"
            title="WhatsApp"
          >
            <AiOutlineWhatsApp />
          </a>
        </div>

        {/* Theme Switcher */}
        <div className="menu-footer">
          <ThemeSwitcher />
        </div>
      </nav>
    </>
  );
};

export default Menu;
